import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-group-profile',
  templateUrl: './about-group-profile.component.html',
  styleUrls: ['./about-group-profile.component.scss']
})
export class AboutGroupProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
